module.exports = __webpack_public_path__ + "static/media/choose-power.b4ab3329.png";